import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDashboardData, getDashboardReportService, getPlayersReport } from 'network/services/dashboard.service'

export const fetchDashboardReport = createAsyncThunk(
  'fetch/DashboardReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getDashboardReportService(params)
      // params?.rakeReport && downloadReport(res?.rakeReport)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchDashboardData = createAsyncThunk(
  'fetch/players-data',
  async (data, thunkApi) => {
    try {
      const res = await getPlayersReport(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchDashboardDataInfo = createAsyncThunk(
  'fetch/dashboard-data',
  async ({ params }, thunkApi) => {
    try {
      const res = await getDashboardData(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
